export const NS = 'StoreCollaboration'
export const STORE_KEY = 'storeCollaboration'
